// MultiSelect's list rules, kept out of the component so they can be tested on their own.

// Options marked searchOnly only turn up once something is typed.
export const filterOptions = (options, search) => {
  const term = String(search || '')
    .trim()
    .toLowerCase();
  return (options || []).filter(
    o =>
      (term || !o.searchOnly) &&
      String(o.text || '')
        .toLowerCase()
        .includes(term),
  );
};

// At most maxTags chips are shown; the rest become a "+N more" chip. 0 shows them all.
export const splitTags = (selected, maxTags) => {
  const visible = maxTags ? selected.slice(0, maxTags) : selected;
  return { visible, hiddenCount: selected.length - visible.length };
};
